import React from 'react'
import { Box, Button, Dialog ,DialogTitle,Stack,Typography} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { removeFromCart } from '../app/features/cart';
function Cartdialog({open,onClose}) {
    const cart = useSelector((state)=>state.cart.cart);
    const totalPrice = useSelector((state)=>state.cart.totalPrice);
    const dispatch = useDispatch();
  return (
   <Dialog open = {open} onClose={onClose} fullWidth={true} maxWidth='sm'>
   <DialogTitle>Shopping Bag</DialogTitle>
   <hr />
   <Box m={3}>
   <Stack direction='column' gap={2}> 
   {
   cart != 0 ? cart?.map((item,index)=>{
    const {img,description,title,price,amount,totalPrice} = item;
    console.log(item);
    return(
        <Box key = {index}>
        <Stack direction='row' spacing={2} justifyContent='space-around' alignItems='center'>
        <Stack direction='column' alignItems='center' justifyContent='center'>
         <img src={img[0]} alt={title} style={{ height:'8em',borderRadius:'20px',width:'7em'}}/>
         <Typography>{title}</Typography>
         <Typography sx={{maxWidth:'15em',fontSize:'15px'}}>{description.slice(0,100)}</Typography>
        </Stack>
        <Box>
         <Typography variant='body1'>Amount: {amount}</Typography>
         <Typography variant='body1'>SingleItem Price: {price}$</Typography>
         <Typography variant='body1'>Total item price: {totalPrice}$</Typography>
         <Button onClick={()=>dispatch(removeFromCart(item))}>Remove</Button>
        </Box>
        </Stack>
        </Box>
    )
 })
  : <Stack direction ='row'><h2>Your bag is Empty</h2>
  <img src={'https://tse2.explicit.bing.net/th?id=OIP.vyMELA_0HIqnrGo0AMDTIgHaKz&pid=Api&P=0&h=180'} alt="emptybag" /></Stack> }
   </Stack>
   </Box>
   <Typography m={2}>
Total price: {totalPrice}$
   </Typography>
   </Dialog>
  )
}

export default Cartdialog
